import { render } from "./ReviewData.vue?vue&type=template&id=2ae627c6&ts=true"
import script from "./ReviewData.ts?vue&type=script&lang=ts&external"
export * from "./ReviewData.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__